import { apiClient } from '../../../shared/api';
import type {
  CreatorListBuildBody,
  CreatorListContactsResponse,
  CreatorListDownloadSummary,
  CreatorListEligibilityResponse,
  CreatorListQueryRequestBody,
  CreatorListQueryResponse,
  CreatorListRegionsResponse,
} from '@aegislab/shared';

// 명단 내려받기 API — docs/design/creator-list-download.md §4, 백엔드 creator-list.controller.ts.

export const getCreatorListEligibility = async (): Promise<CreatorListEligibilityResponse> =>
  (await apiClient.get<CreatorListEligibilityResponse>('/creator-lists/eligibility')).data;

export const getCreatorListRegions = async (): Promise<CreatorListRegionsResponse> =>
  (await apiClient.get<CreatorListRegionsResponse>('/creator-lists/regions')).data;

export const createCreatorListQuery = async (
  body: CreatorListQueryRequestBody
): Promise<CreatorListQueryResponse> =>
  (await apiClient.post<CreatorListQueryResponse>('/creator-lists/queries', body)).data;

export const getCreatorListQuery = async (
  queryRequestId: string
): Promise<CreatorListQueryResponse> =>
  (await apiClient.get<CreatorListQueryResponse>(`/creator-lists/queries/${queryRequestId}`)).data;

export const listCreatorListDownloads = async (): Promise<CreatorListDownloadSummary[]> =>
  (await apiClient.get<CreatorListDownloadSummary[]>('/creator-lists/downloads')).data;

export const createCreatorListDownload = async (
  body: CreatorListBuildBody
): Promise<CreatorListDownloadSummary> =>
  (await apiClient.post<CreatorListDownloadSummary>('/creator-lists/downloads', body)).data;

/** 취소와 지우기는 같은 요청이다(IA §3). */
export const cancelCreatorListDownload = async (downloadId: string): Promise<void> => {
  await apiClient.delete(`/creator-lists/downloads/${downloadId}`);
};

export const redownloadCreatorList = async (
  downloadId: string
): Promise<CreatorListDownloadSummary> =>
  (
    await apiClient.post<CreatorListDownloadSummary>(
      `/creator-lists/downloads/${downloadId}/redownload`
    )
  ).data;

export const getCreatorListContacts = async (
  downloadId: string,
  batch: number
): Promise<CreatorListContactsResponse> =>
  (
    await apiClient.get<CreatorListContactsResponse>(
      `/creator-lists/downloads/${downloadId}/contacts`,
      { params: { batch } }
    )
  ).data;
